export interface Transaction {
  reason: string;
  status: string;
  statusKey?: string;
  operationType: string;
  amount: number;
  referenceNumber: string;
  internalReferenceNumber?: string;
  externalReferenceNumber?: string;
  sourceKey?: string;
  source?: string;
  date: string; 
  /** IN / OUT. Not yet returned by the API; derived from operationType when absent. */
  direction?: 'IN' | 'OUT';
  /** Set for investment-related transactions. */
  opportunityId?: string | null;
}

export interface WalletInfo{
    id:string;
    balance:number;
    pendingAmount?: number;
    viban:string;
}

/** Matches the API's WalletTransactionCategory enum names. */
export type WalletMovementKind = 'Internal' | 'External';

export interface WalletTransactionsFilter {
  fromDate?: string | null;
  toDate?: string | null;
  /** true = newest first (default). */
  newestFirst?: boolean;
  minAmount?: number | null;
  maxAmount?: number | null;
  /** null = all types for the current movement kind. */
  transactionType?: WalletTxTypeFilter | null;
}

/** Matches the API's WalletMovementType enum names (and the transactionTypeKey values in the list). */
export type WalletTxTypeFilter = 'WalletTopUp' | 'Withdrawal' | 'Investment' | 'ProfitDistribution' | 'Refund';

/** Each type lives on one tab: top-ups and withdrawals are External, the rest are Internal. */
export const WALLET_TX_TYPE_OPTIONS: ReadonlyArray<{ value: WalletTxTypeFilter; kind: WalletMovementKind }> = [
  { value: 'WalletTopUp', kind: 'External' },
  { value: 'Withdrawal', kind: 'External' },
  { value: 'Investment', kind: 'Internal' },
  { value: 'ProfitDistribution', kind: 'Internal' },
  { value: 'Refund', kind: 'Internal' },
];

export interface InvestorWalletBalance {
  balance: number;
  pendingBalance: number;
}

export interface InvestorVibanInfo {
  virtualIban: string;
  accountNumber?: string;
  walletId?: string;
}

export interface InvestorWithdrawLimitsInfo {
  maxWithdrawAmountPerTransaction: number;
  maxWithdrawAmountPerDay: number;
  withdrawnAmountToday: number;
  messageAr: string;
  messageEn: string;
}

export interface WalletWithdrawRequest {
  amount: number;
  bankAccountId: string;
}

export const MOYASAR_WALLET_REDIRECT_PATH_SESSION_KEY = 'moyasarWalletRedirectPath';

/** Holds the active mobile-charge token while the phone completes the Moyasar redirect. */
export const MOBILE_CHARGE_TOKEN_SESSION_KEY = 'mobileChargeToken';

/** Status values returned by the backend MobileChargeSession. */
export type MobileChargeSessionStatus =
  | 'Pending'
  | 'Completed'
  | 'Expired'
  | 'Failed'
  | 'Cancelled'
  | 'Processing';

export interface MobileChargeSession {
  token: string;
  amount: number;
  status: MobileChargeSessionStatus;
  expiresAtUtc: string;
  checkoutId?: string;
}

export interface MobileChargeSessionCompleteResult {
  status: string;
  amount: number;
  redirectUrl?: string;
}

export interface MoyasarClientConfig {
  enabled: boolean;
  publishableKey: string;
  cardNetworks?: string[];
  applePayEnabled?: boolean;
}